// export const BACKEND_URL = "http://localhost:80";
export const BACKEND_URL = "https://ai-chat-demo-backend-5ky6pp3tgq-uc.a.run.app";
export const VOICE_BACKEND_URL = "https://ai-zbot-speech-backend-5ky6pp3tgq-uc.a.run.app";
// export const VOICE_BACKEND_URL = "http://localhost:8000";